

<div class="section">
  <div class="section-header" (click)="toggle()">
    <h2 class="label-tiny">{{title}}</h2>
        <i class="fas" [ngClass]="{
            'fa-angle-up': isOpen,
            'fa-angle-down': !isOpen
        }"></i>
  </div>
  @if (isOpen) {
    <div class="section-content">
      <ng-content></ng-content>
    </div>
  }

</div>